import React from 'react';
import { MeetingPage } from './pages/MeetingPage';
export function App() {
  return <MeetingPage data-id="element-0" />;
}